var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './Breadcrumbs.styles.scss';
import { Icon, Link } from '@gerdau/hefesto';
var Breadcrumbs = function (_a) {
    var breadcrumbItems = _a.breadcrumbItems, onClick = _a.onClick;
    return (_jsx("nav", { children: _jsx("ol", __assign({ className: "hefesto-breadcrumbs" }, { children: breadcrumbItems.map(function (item, index, array) {
                return (_jsx(BreadcrumbItem, { index: index + 1, isLast: array.length - 1 === index, onClick: onClick, item: {
                        url: item.url,
                        name: item.name,
                    } }, index));
            }) })) }));
};
var BreadcrumbItem = function (_a) {
    var item = _a.item, index = _a.index, isLast = _a.isLast, onClick = _a.onClick;
    return (_jsx(_Fragment, { children: isLast
            ? lastCrumb({ key: index, url: '', name: item.name, onClick: onClick })
            : crumb({ key: index, url: item.url, name: item.name, onClick: onClick }) }));
};
var lastCrumb = function (_a) {
    var key = _a.key, name = _a.name;
    return (_jsx("li", __assign({ className: "hefesto-breadcrumbs" }, { children: _jsx("span", __assign({ itemProp: "name", className: "hefesto-breadcrumbs__label" }, { children: name })) }), key));
};
var crumb = function (_a) {
    var key = _a.key, url = _a.url, name = _a.name, onClick = _a.onClick;
    return (_jsxs("li", __assign({ className: "hefesto-breadcrumbs" }, { children: [_jsx(Link, { url: url, name: name, onClick: onClick }), _jsx("i", __assign({ className: "hefesto-breadcrumbs__chevronright-icon" }, { children: _jsx(Icon, { option: "ChevronRight", variant: "primary" }) }))] }), key));
};
export default Breadcrumbs;
